export default "__VITE_ASSET__DsKSlA4e__"